import api from '../network/apiClient';
import { SessionAPIsI } from './types';

let csrfRequestPromise: Promise<void>;

const fetchCsrfCookie = async (sessionAPIs: SessionAPIsI): Promise<void> => {
  await api(sessionAPIs.csrf);
};

export const getCsrfToken = (sessionAPIs: SessionAPIsI): void => {
  csrfRequestPromise = fetchCsrfCookie(sessionAPIs);
};

export const ensureCsrfLoaded = async (): Promise<void> => {
  await csrfRequestPromise;
};
